import moment from 'moment';
import { Flex } from '../UI/Flex/Flex';
import * as style from './ChatMessage.module.less';

import { ChatMessageData } from '@assets/model/RagAPI';
import DOMPurify from 'dompurify';
import { marked, Tokens } from 'marked';
import { LogoBird } from '../Header/Logo';
import { observer } from 'mobx-react';
import { useStore } from '@assets/model/Store';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'react-tooltip';

interface ChatMessageProps {
    msgId: string;
    msg: ChatMessageData;
    response?: boolean;
}

export const ChatMessage = observer((p: ChatMessageProps) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [activeContent, setActiveContent] = useState(null);
    const msg: ChatMessageData = p.msg;
    const firmURL = useStore().firmInfo.logoURL;
    const clssses = classNames(style.chatmessage, 'fade-in');
    const msgId = p.msgId;
    const companyId = useStore().selectedReportId;

    const buildTooltipId = (msgId: string, citationDisplayId: string) => {
        return `tooltip_${companyId}_${msgId}_${citationDisplayId}`;
    };

    if (msg.isMe) {
        return (
            <>
                <Flex className={clssses} direction="column">
                    <div
                        style={{
                            height: '50px',
                            alignSelf: 'end',
                            marginBottom: '10px'
                        }}
                    >
                        <img
                            height={50}
                            width={200}
                            src={firmURL}
                            style={{
                                objectFit: 'contain',
                                objectPosition: 'right',
                                height: '100%'
                                //filter: 'invert(1)'
                            }}
                        />
                    </div>

                    <div
                        style={{
                            textAlign: 'right',
                            marginRight: '10px',
                            alignSelf: 'end'
                        }}
                    >
                        {msg.message}
                    </div>
                </Flex>
                {/* {files_references} */}
            </>
        );
    }

    const convertMarkdown = (markdown: string, messageId: string): string => {
        const cls = style.citation_class;
        const rawHtmlWithDefault = marked.parse(markdown as string) as string;

        var matchCounter = 0;
        const finalOutput = rawHtmlWithDefault.replace(
            /\[(.*?)\]/g,
            (match, p1) => {
                matchCounter++;
                const tooltipId = buildTooltipId(messageId, p1);
                return `<a class='${cls}' data-tooltip-id="${tooltipId}">${matchCounter}</a>`;
            }
        );

        return DOMPurify.sanitize(finalOutput as string);
    };

    const formatterHTML = convertMarkdown(msg.message, msgId);
    var tooltips = [];
    if (msg.raw && msg.raw.citations) {
        const citations = msg.raw.citations;
        //data-tooltip-id="my-tooltip

        tooltips = citations.map((citation, index) => {
            try {
                const toolGenId = msg.raw.citations[index].id;
                const tooltipId = buildTooltipId(msgId, toolGenId);
                var text = msg.raw.citations[index].payload?.text;
                if (!text) {
                    text = msg.raw.citations[index].text;
                }

                return (
                    <Tooltip
                        key={toolGenId + '_' + index}
                        id={tooltipId}
                        style={{ maxWidth: '400px', zIndex: 9999 }}
                    >
                        {text}
                    </Tooltip>
                );
            } catch (e) {
                console.error('Error in tooltip generation', e);
                console.error('Citation:', citation);
                return null;
            }
        });
    }

    return (
        <>
            <Flex className={clssses} direction="row">
                {tooltips}
                <div className="p-3" style={{ height: '50px' }}>
                    <LogoBird />
                </div>
                <div
                    ref={contentRef}
                    className="flex-grow-1 p-4 align-self-center"
                    style={{ marginLeft: '0px' }}
                >
                    <div dangerouslySetInnerHTML={{ __html: formatterHTML }} />
                </div>
            </Flex>
            {/* {files_references} */}
        </>
    );
});
